import { ModalBackground, StyledModal } from "./styled";
import "animate.css"
import { useState } from "react";

const ModalDefault = ({children , title, closeModal, callback})=>{

    const submit = (e)=>{
        e.preventDefault();
        callback();
    }

    return(
        <ModalBackground>
            <StyledModal className="animate__animated animate__zoomIn">
                <header>
                    <h2>{title}</h2>
                    <button onClick={()=>closeModal()}>X</button>
                </header>
                <form onSubmit={submit}>
                    {children}
                </form>
            </StyledModal>
        </ModalBackground>
    )
}

export default ModalDefault